import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  PersonProfileSkeleton,
  PagedPersonProfileAudit,
  PagedBusinessPersonAudit,
  PagedPhoneNumberAudit,
  PagedEmailAddressAudit,
  PagedAddressAudit,
  PagedEmergencyContactAudit,
  PagedPersonAttributeAudit,
  PagedStaffInfoAudit,
  PagedPreferenceAudit,
  PagedExecutiveAssociateAudit,
  PagedCrewMemberTypeRatingAudit,
  PagedTaxInfoAudit,
  PagedPersonStaffGroupAudit,
  PagedPassengerAudit
} from './+models/person-profile-audit.model';

@Injectable()
export class PersonProfileAuditService {
  constructor(private readonly http: HttpClient) {}

  getPersonProfileAudits(
    personId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/${personId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedPersonProfileAudit>(url);
  }

  getBusinessPersonAudits(
    businessPersonId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/BusinessPerson/${businessPersonId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedBusinessPersonAudit>(url);
  }

  getPhoneNumberAudits(
    phoneNumberId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/PhoneNumber/${phoneNumberId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedPhoneNumberAudit>(url);
  }

  getEmailAddressAudits(
    emailAddressId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/EmailAddress/${emailAddressId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedEmailAddressAudit>(url);
  }

  getAddressAudits(
    addressId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/Address/${addressId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAddressAudit>(url);
  }

  getEmergencyContactAudits(
    emergencyContactId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/EmergencyContact/${emergencyContactId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedEmergencyContactAudit>(url);
  }

  getEmergencyContactPhoneNumberAudits(
    emergencyContactPhoneNumberId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/EmergencyContactPhoneNumber/${emergencyContactPhoneNumberId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedPhoneNumberAudit>(url);
  }

  getPersonAttributeAudits(
    personAttributeId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/PersonAttribute/${personAttributeId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedPersonAttributeAudit>(url);
  }

  getPersonStaffGroupAudits(
    personStaffGroupId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/PersonStaffGroup/${personStaffGroupId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedPersonStaffGroupAudit>(url);
  }

  getStaffInfoAudits(
    staffInfoId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/StaffInfo/${staffInfoId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedStaffInfoAudit>(url);
  }

  getPreferenceAudits(
    preferenceId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/Preference/${preferenceId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedPreferenceAudit>(url);
  }

  getExecutiveAssociateAudits(
    executiveAssociateId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/ExecutiveAssociate/${executiveAssociateId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedExecutiveAssociateAudit>(url);
  }

  getCrewMemberTypeRatingAudits(
    crewMemberTypeRatingId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/CrewMemberTypeRating/${crewMemberTypeRatingId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedCrewMemberTypeRatingAudit>(url);
  }

  getTaxInfoAudits(
    taxInfoId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/TaxInfo/${taxInfoId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedTaxInfoAudit>(url);
  }

  getPassengerAudits(
    passengerId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/PersonAudit/Passenger/${passengerId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedPassengerAudit>(url);
  }

  getPersonProfileSkeleton(personId: number) {
    return this.http.get<PersonProfileSkeleton>(
      `/sdapi/profile/PersonAudit/PersonSkeleton/${personId}`
    );
  }
}
